import { useEffect } from "react";
import LegalLayout from "@/components/LegalLayout";

const CopyrightPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <LegalLayout title="Copyright & Takedown Policy" lastUpdated="February 2026">
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          1. Intellectual Property Ownership
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          <strong>LoBe Owned Content:</strong>
        </p>
        <ul className="list-disc list-inside text-[#5A5A5A] space-y-2 mb-4">
          <li>The LoBe name, logo, and brand identity</li>
          <li>Certificate templates and designs</li>
          <li>Website design, code, and functionality</li>
          <li>Marketing materials and content</li>
        </ul>
        <p className="text-[#5A5A5A]">
          <strong>User-Owned Content:</strong> You retain ownership of the personal content you provide 
          (names, descriptions) for your certificate. By creating a certificate, you grant LoBe a 
          non-exclusive license to display, process, and store this content for the purpose of 
          providing our service.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          2. Prohibited Content
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          You may not create certificates containing:
        </p>
        <ul className="list-disc list-inside text-[#5A5A5A] space-y-2">
          <li>Content that infringes on others' intellectual property rights</li>
          <li>Defamatory, obscene, or offensive material</li>
          <li>Content that violates any person's privacy rights</li>
          <li>Names of individuals without their consent</li>
          <li>Hate speech or discriminatory content</li>
          <li>Content promoting illegal activities</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          3. Reporting Abuse
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          If you believe a certificate contains content that violates these policies, you can report it to us:
        </p>
        <div className="bg-[#F4F1EA] rounded-xl p-4 mb-4">
          <p className="text-[#5A5A5A] mb-2">
            <strong>Email:</strong>{" "}
            <a href="mailto:support@lobe.love" className="text-[#E8A0BF] hover:underline">
              support@lobe.love
            </a>
          </p>
          <p className="text-[#5A5A5A]">
            Please include the certificate ID or URL and a description of the violation.
          </p>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          4. Content Removal Procedure
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          Upon receiving a valid abuse report, we will:
        </p>
        <ol className="list-decimal list-inside text-[#5A5A5A] space-y-2">
          <li>Review the reported content within 48 hours</li>
          <li>Assess whether it violates our policies</li>
          <li>Take appropriate action, which may include:
            <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
              <li>Removing the certificate</li>
              <li>Contacting the certificate creator</li>
              <li>Preserving content for legal purposes if required</li>
            </ul>
          </li>
          <li>Notify the reporter of our decision (when appropriate)</li>
        </ol>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          5. DMCA Notice
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          If you believe your copyrighted work has been used inappropriately, please send a DMCA 
          takedown notice to our designated agent:
        </p>
        <div className="bg-[#F4F1EA] rounded-xl p-4">
          <p className="text-[#5A5A5A]">
            <strong>Email:</strong>{" "}
            <a href="mailto:support@lobe.love" className="text-[#E8A0BF] hover:underline">
              support@lobe.love
            </a>
          </p>
          <p className="text-sm text-[#888888] mt-2">
            Your notice must include: identification of the copyrighted work, identification of the 
            infringing material, your contact information, and a statement of good faith belief.
          </p>
        </div>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          6. Repeat Infringers
        </h2>
        <p className="text-[#5A5A5A]">
          We reserve the right to terminate access for users who repeatedly violate these policies.
        </p>
      </section>
    </LegalLayout>
  );
};

export default CopyrightPage;
